module.exports = __webpack_public_path__ + "img/2-4.da7a8cae.png";